import { bl_mrp_job_template_to_process_template_link_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class MrpJobTemplateToProcessTemplateLinkContainerModel extends BaseContainerModel {
  bl_mrp_job_template_to_process_template_link: bl_mrp_job_template_to_process_template_link_RowClass = new bl_mrp_job_template_to_process_template_link_RowClass();
}
